"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9918],{

/***/ 38100:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AppError_AppError; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/ApplicationError/index.js
var ApplicationError = __webpack_require__(66651);
// EXTERNAL MODULE: ./src/AppError/error-prop-type.js
var error_prop_type = __webpack_require__(76965);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Link/index.js + 1 modules
var Link = __webpack_require__(25522);
// EXTERNAL MODULE: ./src/routes.js
var routes = __webpack_require__(30233);
;// CONCATENATED MODULE: ./src/AppError/Error400.js






const Error400 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Bad Request"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you didn’t provide all mandatory inputs or provided data was incorrect.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error400 = (Error400);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/AppError/Error401.js







const Error401 = ()=>{
    const { asPath  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Authorized"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. You are not authorized to access the requested resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: "".concat(routes/* default.auth.logout */.Z.auth.logout, "?returnUrl=").concat(encodeURIComponent(asPath)),
                        children: "sign in"
                    }),
                    " ",
                    "with a different account, or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
};
/* harmony default export */ var AppError_Error401 = (Error401);

;// CONCATENATED MODULE: ./src/AppError/Error403.js






const Error403 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Permitted"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry, you don’t have sufficient permissions to access this resource.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error403 = (Error403);

;// CONCATENATED MODULE: ./src/AppError/Error404.js




const Error404 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Not Found"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. The requested resource was not found."
            })
        ]
    });
/* harmony default export */ var AppError_Error404 = (Error404);

;// CONCATENATED MODULE: ./src/AppError/Error500.js






const Error500 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Something went wrong"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: [
                    "We’re sorry. Something has gone wrong with the application.",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                    "Please try again later or",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                        sx: {
                            fontSize: "s"
                        },
                        href: routes/* default.external.contactUs */.Z.external.contactUs,
                        children: "contact us"
                    }),
                    " ",
                    "for further assistance."
                ]
            })
        ]
    });
/* harmony default export */ var AppError_Error500 = (Error500);

;// CONCATENATED MODULE: ./src/AppError/Error503.js




const Error503 = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "Service Unavailable"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable."
            })
        ]
    });
/* harmony default export */ var AppError_Error503 = (Error503);

// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/r1/atoms/ContentContainer/index.js
var ContentContainer = __webpack_require__(12985);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/AppError/ErrorDetails.js






const ErrorDetails = (param)=>/*#__PURE__*/ {
    let { error  } = param;
    return (0,jsx_runtime.jsx)(ContentContainer/* default */.Z, {
        mx: true,
        md: 10,
        lg: 8,
        center: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
            utility: {
                radius: 6,
                bgColor: "black"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
                className: " text-color-white px-5 py-5",
                children: JSON.stringify(error, null, 2)
            })
        })
    });
};
ErrorDetails.propTypes = {
    error: error_prop_type/* default */.Z
};
/* harmony default export */ var AppError_ErrorDetails = (config/* publicConfig.DEBUG_MODE */.mn.DEBUG_MODE ? ErrorDetails : ()=>null);

// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
// EXTERNAL MODULE: ./src/sentry.js + 68 modules
var sentry = __webpack_require__(47950);
;// CONCATENATED MODULE: ./src/AppError/AppError.js














const errorComponents = {
    400: AppError_Error400,
    401: AppError_Error401,
    403: AppError_Error403,
    404: AppError_Error404,
    503: AppError_Error503
};
const AppError = (param)=>{
    let { error , Layout =ErrorLayout/* default */.Z , ...props } = param;
    const { code  } = error;
    const ErrorComponent = errorComponents[code] || AppError_Error500;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout, {
        extra: /*#__PURE__*/ (0,jsx_runtime.jsx)(AppError_ErrorDetails, {
            error: error
        }),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorComponent, {
            error: error
        })
    });
};
AppError.getInitialProps = (context)=>{
    const { err , res  } = context;
    const error = ApplicationError/* default.of */.Z.of(err !== null && err !== void 0 ? err : {});
    if (res) {
        res.statusCode = error.code;
    }
    (0,sentry/* notifySentry */.Yw)(err, context);
    if (error.code >= 500 && error.code !== 503 && error.originalError != null) throw error.originalError;
    return {
        error: error.toSerializable()
    };
};
AppError.propTypes = {
    error: error_prop_type/* default */.Z,
    Layout: prop_types.elementType
};
/* harmony default export */ var AppError_AppError = (AppError);


/***/ }),

/***/ 59093:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87385);
/* harmony import */ var _insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93512);
/* harmony import */ var _SiteLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26485);






/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode }>} */ const ErrorLayout = (param)=>/*#__PURE__*/ {
    let { children , extra  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        isWrapper: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayout.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_5__.node,
    extra: prop_types__WEBPACK_IMPORTED_MODULE_5__.node
};
/** @type {React.FC<{ children: React.ReactNode, extra: React.ReactNode, isAuthorized: boolean }>} */ const ErrorLayoutPure = (param)=>/*#__PURE__*/ {
    let { children , extra , isAuthorized  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_SiteLayout__WEBPACK_IMPORTED_MODULE_4__/* ["default"].Pure */ .Z.Pure, {
        isAuthorized: isAuthorized,
        isWrapper: false,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_SimpleTemplate__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                children: children
            }),
            extra && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Section__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                spacing: {
                    pt: 9,
                    pb: 18,
                    md: {
                        pt: 9,
                        pb: 18
                    }
                },
                children: extra
            })
        ]
    });
};
ErrorLayoutPure.propTypes = {
    ...ErrorLayout.propTypes,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_5__.bool
};
ErrorLayout.Pure = ErrorLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (ErrorLayout);


/***/ }),

/***/ 76965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);

/* harmony default export */ __webpack_exports__["Z"] = ((0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
    code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
    message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
    stack: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.arrayOf)(prop_types__WEBPACK_IMPORTED_MODULE_0__.string),
    originalError: (0,prop_types__WEBPACK_IMPORTED_MODULE_0__.shape)({
        name: prop_types__WEBPACK_IMPORTED_MODULE_0__.string,
        code: prop_types__WEBPACK_IMPORTED_MODULE_0__.number,
        message: prop_types__WEBPACK_IMPORTED_MODULE_0__.string
    })
}));


/***/ }),

/***/ 71802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10455);
/* harmony import */ var _AppError__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38100);




const withErrorHandling = (Component)=>{
    const WithErrorHandling = (param)=>{
        let { error , ...props } = param;
        if (error == null) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                ...props
            });
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            error: error
        });
    };
    Object.assign(WithErrorHandling, Component);
    WithErrorHandling.propTypes = _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes;
    WithErrorHandling.getInitialProps = (context, container)=>{
        try {
            const props = Component.getInitialProps ? Component.getInitialProps(context, container) : {};
            return (0,_insightfulscience_shared_utils_fn__WEBPACK_IMPORTED_MODULE_3__/* .isPromise */ .tI)(props) ? props.catch((err)=>{
                return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                    ...context,
                    err
                }, container);
            }) : props;
        } catch (err) {
            return _AppError__WEBPACK_IMPORTED_MODULE_2__/* ["default"].getInitialProps */ .Z.getInitialProps({
                ...context,
                err
            }, container);
        }
    };
    return WithErrorHandling;
};
/* harmony default export */ __webpack_exports__["Z"] = (withErrorHandling);


/***/ }),

/***/ 25890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Maintenance_WithMaintenance; }
});

// EXTERNAL MODULE: ./node_modules/@insightfulscience/smart-react/hocs/WithMaintenance/index.js + 1 modules
var WithMaintenance = __webpack_require__(77358);
// EXTERNAL MODULE: ./src/services/index.js + 11 modules
var services = __webpack_require__(69549);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Heading/index.js + 1 modules
var Heading = __webpack_require__(42866);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Paragraph/index.js + 1 modules
var Paragraph = __webpack_require__(74229);
// EXTERNAL MODULE: ./src/AppError/ErrorLayout.js
var ErrorLayout = __webpack_require__(59093);
;// CONCATENATED MODULE: ./src/Maintenance/Maintenance.jsx





const Maintenance = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(ErrorLayout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                Tag: "h1",
                sx: {
                    fontSize: "xl",
                    fontColor: "3",
                    textAlign: "center"
                },
                spacing: {
                    mb: 6
                },
                children: "We’re undergoing maintenance."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Paragraph/* default */.Z, {
                sx: {
                    fontSize: "s",
                    textAlign: "center"
                },
                children: "We’re sorry. We’re temporarily unavailable. Please come back later."
            })
        ]
    });
/* harmony default export */ var Maintenance_Maintenance = (Maintenance);

;// CONCATENATED MODULE: ./src/Maintenance/WithMaintenance.js



/* harmony default export */ var Maintenance_WithMaintenance = ((0,WithMaintenance/* default */.Z)({
    MaintenanceComp: Maintenance_Maintenance,
    serviceCore: services/* serviceCore */.T
}));


/***/ }),

/***/ 26485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(71412);
/* harmony import */ var _SiteFooter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(49478);
/* harmony import */ var _SiteHeader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5255);
/* harmony import */ var _services_authService_hooks__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11969);







const SiteLayoutPure = (param)=>{
    let { bodyClassName ="" , footerClassName ="" , children , isAuthorized , isWrapper =true , headerClassName , HeaderComponent =_SiteHeader__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        isWrapper: isWrapper,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Header */ .Z.Header, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(HeaderComponent, {
                    ...props,
                    isAuthorized: true,
                    className: headerClassName
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Body */ .Z.Body, {
                className: bodyClassName,
                children: children
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_insightfulscience_atomic_react_Layout__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Footer */ .Z.Footer, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SiteFooter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: footerClassName
                })
            })
        ]
    });
};
SiteLayoutPure.propTypes = {
    bodyClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    footerClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    headerClassName: prop_types__WEBPACK_IMPORTED_MODULE_6__.string,
    isAuthorized: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    isWrapper: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_6__.node,
    hero: prop_types__WEBPACK_IMPORTED_MODULE_6__.bool,
    HeaderComponent: prop_types__WEBPACK_IMPORTED_MODULE_6__.elementType
};
const SiteLayout = (props)=>{
    const isAuthorized = (0,_services_authService_hooks__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SiteLayoutPure, {
        ...props,
        isAuthorized: isAuthorized
    });
};
SiteLayout.Pure = SiteLayoutPure;
/* harmony default export */ __webpack_exports__["Z"] = (SiteLayout);


/***/ }),

/***/ 41802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Qc": function() { return /* binding */ ACTION_STATUSES; },
  "qb": function() { return /* binding */ MIN_TRANS_AMOUNT; },
  "qq": function() { return /* binding */ SUBSCRIPTION_STATUS; },
  "wx": function() { return /* binding */ allowChangePlan; },
  "K_": function() { return /* binding */ allowSubscriptionAddons; },
  "jf": function() { return /* binding */ allowSubscriptionRenew; },
  "qd": function() { return /* binding */ getAlertInfo; },
  "bW": function() { return /* binding */ getBillingInfo; },
  "hz": function() { return /* binding */ hasSusbscriptionDunning; },
  "_M": function() { return /* binding */ isActivationManagementAllowed; },
  "S1": function() { return /* binding */ isAllowSubscriptionChangePlanOperation; },
  "el": function() { return /* binding */ isAllowSubscriptionRenewalOperation; },
  "yt": function() { return /* binding */ isAllowSubscriptionViewInvoiceOperation; },
  "X7": function() { return /* binding */ isHasPaymentMethod; },
  "sJ": function() { return /* binding */ isManualSubscription; },
  "AK": function() { return /* binding */ isPersonalUpgradeToGroupAllowed; },
  "s8": function() { return /* binding */ isPurchaseGroupAllowed; },
  "nZ": function() { return /* binding */ isPurchaseSubscription; },
  "N5": function() { return /* binding */ isRenewSubscription; },
  "XN": function() { return /* binding */ isRenewToGroupAllowed; },
  "sD": function() { return /* binding */ isSerialNumberGenerationPending; },
  "xC": function() { return /* binding */ isSubscriptionActive; },
  "gd": function() { return /* binding */ isSubscriptionCancelled; },
  "Z1": function() { return /* binding */ isSubscriptionExpired; },
  "BA": function() { return /* binding */ isSubscriptionReturned; },
  "qN": function() { return /* binding */ isTrialUpgradeToGroupAllowed; },
  "KS": function() { return /* binding */ statusEventName; },
  "me": function() { return /* binding */ subscriptionActiveActivations; },
  "mW": function() { return /* binding */ subscriptionBlacklistedActivations; },
  "X_": function() { return /* binding */ subscriptionDeactivatedActivations; }
});

// UNUSED EXPORTS: isAllowSubscriptionAddonOperation, isAutoBillingSubscription, isPurchaseActivationAllowed, isRenewGroupAllowed

// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/dates/dateDiff.js
var dateDiff = __webpack_require__(81465);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/shared-utils/parsers/parseFullName.js
var parseFullName = __webpack_require__(88604);
// EXTERNAL MODULE: ./src/domain/plan.js
var domain_plan = __webpack_require__(8598);
;// CONCATENATED MODULE: ./src/utils/daysBeforeNow.js

const daysBeforeNow = (date)=>(0,dateDiff/* diffDays */.M)(new Date(), new Date(date));

// EXTERNAL MODULE: ./src/config.js
var config = __webpack_require__(89032);
;// CONCATENATED MODULE: ./src/domain/subscription.js





const DAYS_TO_ALLOW_RENEW = 60;
const SUBSCRIPTION_STATUS = {
    ACTIVE: "active",
    CANCELLED: "cancelled",
    EXPIRED: "expired",
    DUNNING: "past-due"
};
const ACTION_STATUSES = {
    REACTIVATED_SUCCESSFULLY: {
        status: "success"
    },
    CANCELLED_SUCCESSFULLY: {
        status: "success"
    },
    BILLING_INFO_UPDATED_SUCCESSFULLY: {
        status: "success"
    },
    UPDATED_PAYMENT_METHOD: "UPDATED_PAYMENT_METHOD",
    SUBSCRIPTION_WAS_UPDATED: "SUBSCRIPTION_WAS_UPDATED",
    SUBSCRIPTION_PLAN_WAS_CHANGED: "SUBSCRIPTION_PLAN_WAS_CHANGED"
};
const ORDER_STATUS = {
    PENDING: "pending",
    CANCELLED: "cancelled"
};
const getAlertInfo = (action)=>action && ACTION_STATUSES[action.toUpperCase()];
const hasSusbscriptionDunning = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.ACTIVE && Array.isArray(subscription.orders) && subscription.orders.some((param)=>{
        let { status , createdBy  } = param;
        return status === ORDER_STATUS.PENDING && createdBy === "webhook";
    });
/** @typedef {"active" | "canceled" | "expired"} Status */ /** @type {(subsciption: {isAutoBillingEnabled: Boolean, expirationDate: string | Date, status: Status }) => boolean} */ const isSubscriptionExpired = (param)=>{
    let { isAutoBillingEnabled , expirationDate , status  } = param;
    const now = new Date();
    return isAutoBillingEnabled ? status === SUBSCRIPTION_STATUS.EXPIRED : (0,dateDiff/* diffDays */.M)(now, new Date(expirationDate)) < 0 || status === SUBSCRIPTION_STATUS.EXPIRED;
};
/** @type {(subsciption: { status: Status }) => boolean} */ const isSubscriptionCancelled = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.CANCELLED;
/** @type {(subsciption: { status: Status }) => boolean} */ const isSubscriptionActive = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.ACTIVE && !isSubscriptionExpired(subscription) && !hasSusbscriptionDunning(subscription);
/** @type {(subsciption: { status: Status, archiveBit: boolean }) => boolean} */ const isSubscriptionReturned = (subscription)=>subscription.status === SUBSCRIPTION_STATUS.EXPIRED && subscription.archiveBit;
/** @type {(subsciption: { isAutoBillingEnabled: boolean }) => boolean} */ const isAutoBillingSubscription = (subscription)=>subscription.isAutoBillingEnabled;
/** @type {(plan: { type, planCode }) => boolean} */ const isPersonalUpgradeToGroupAllowed = (plan)=>(0,domain_plan/* isIsul */.O4)(plan.planCode) && (0,domain_plan/* isPersonalPlan */.VV)(plan) ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
/** @type {(plan: { type, planCode }) => boolean} */ const isRenewToGroupAllowed = (plan)=>(0,domain_plan/* isIsul */.O4)(plan.planCode) && (0,domain_plan/* isPersonalPlan */.VV)(plan) ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
const isRenewGroupAllowed = (plan)=>(0,domain_plan/* isIsul */.O4)(plan.planCode) && (0,domain_plan/* isGroupPlan */.cF)(plan) ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
/** @type {(plan: { type, planCode }) => boolean} */ const isPurchaseActivationAllowed = (plan)=>(0,domain_plan/* isIsul */.O4)(plan.planCode) && (0,domain_plan/* isGroupPlan */.cF)(plan) ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
/** @type {(subscription: { plan: { type, planCode }, isTrial }) => boolean} */ const isTrialUpgradeToGroupAllowed = (param)=>{
    let { plan , isTrial  } = param;
    return (0,domain_plan/* isIsul */.O4)(plan.planCode) && isTrial ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
};
/** @type {(planCode) => boolean} */ const isPurchaseGroupAllowed = (planCode)=>(0,domain_plan/* isIsulGroup */.Uj)(planCode) ? config/* publicConfig.IS_ISUL_GROUP_ENABLED */.mn.IS_ISUL_GROUP_ENABLED : true;
/** @type {(subsciption: { allowedOperations: AllowedOperations }) => boolean} */ const isAllowSubscriptionAddonOperation = (subscription)=>{
    var ref;
    return (subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.addons) && isPurchaseActivationAllowed(subscription.plan);
};
/** @type {(subsciption: { allowedOperations: AllowedOperations, plan: { planCode } }) => boolean} */ const isAllowSubscriptionChangePlanOperation = (subscription)=>{
    var ref;
    return (subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.changePlan) && isPersonalUpgradeToGroupAllowed(subscription.plan);
};
/** @type {(subsciption: { allowedOperations: AllowedOperations }) => boolean} */ const isAllowSubscriptionViewInvoiceOperation = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.viewInvoice;
};
/** @type {(subsciption: { allowedOperations: AllowedOperations }) => boolean} */ const isAllowSubscriptionRenewalOperation = (subscription)=>{
    var ref;
    return (subscription === null || subscription === void 0 ? void 0 : (ref = subscription.allowedOperations) === null || ref === void 0 ? void 0 : ref.renewal) && isRenewGroupAllowed(subscription.plan);
};
/** @type {(subsciption: {
	status: Status;
	isAutobilling: boolean;
	expirationDate: string | Date;
}) => boolean} */ const allowSubscriptionRenew = (subsciption)=>// prettier-ignore
    !isAutoBillingSubscription(subsciption) && (isSubscriptionActive(subsciption) && daysBeforeNow(subsciption.expirationDate) <= DAYS_TO_ALLOW_RENEW || isSubscriptionExpired(subsciption));
/** @type {(subsciption: {
	status: Status;
	isAutobilling: boolean;
	expirationDate: string | Date;
}) => "EXPIRED" | "RENEWS" | "EXPIRES"} */ const statusEventName = (subscription)=>{
    const isExpired = isSubscriptionExpired(subscription);
    const isActive = isSubscriptionActive(subscription);
    const isAutoBillingEnabled = isAutoBillingSubscription(subscription);
    const isDunning = hasSusbscriptionDunning(subscription);
    return isExpired && "EXPIRED" || isAutoBillingEnabled && (isActive || isDunning) && "RENEWS" || "EXPIRES";
};
/** @type {(subsciption: {
	status: Status;
	plan: {};
	isAutobilling: boolean;
	expirationDate: string | Date;
}) => boolean} */ const allowSubscriptionAddons = (subscription)=>subscription.plan != null && isSubscriptionActive(subscription) && (0,domain_plan/* isGroupPlan */.cF)(subscription.plan) && !hasSusbscriptionDunning(subscription) && isAllowSubscriptionAddonOperation(subscription);
/** @type {(subscription: {
 	billingName: string | undefined;
	billingEmail: string | undefined;
 	billingCompany: string | undefined;
	billingDepartment: string | undefined;
	billingAddress1: string | undefined;
	billingAddress2: string | undefined;
	billingCity: string | undefined;
	billingState: string | undefined;
	billingZipCode: string | undefined;
	billingCountryID: number | undefined;
	billingPhoneNumber: string | undefined;
 }) => {
	company: string | undefined;
	address1: string | undefined;
	address2: string | undefined;
	address3: string | undefined;
	city: string | undefined;
	state: string | undefined;
	zipCode: string | undefined;
	countryID: number | undefined;
	phoneNumber: string | undefined;
 }} */ const getBillingInfo = (param)=>{
    let { billingName , billingEmail , billingCompany , billingDepartment , billingAddress1 , billingAddress2 , billingCity , billingState , billingZipCode , billingCountryID , billingPhoneNumber  } = param;
    return {
        email: billingEmail,
        ...(0,parseFullName/* parseFullName */.b)(billingName),
        company: billingCompany,
        address1: billingDepartment,
        address2: billingAddress1,
        address3: billingAddress2,
        city: billingCity,
        state: billingState,
        zipCode: billingZipCode,
        countryID: billingCountryID,
        phone: billingPhoneNumber
    };
};
const isManualSubscription = (param)=>{
    let { externalID , isAutoBillingEnabled  } = param;
    return externalID === null && !isAutoBillingEnabled;
};
const isActivationManagementAllowed = (param)=>{
    let { serialNumbers  } = param;
    return !!serialNumbers.find((item)=>item.isActivationManagementAllowed === true);
};
const subscriptionActiveActivations = (serialNumbers)=>serialNumbers[0].activations.filter((item)=>item.activationStatus === "active");
const subscriptionDeactivatedActivations = (serialNumbers)=>serialNumbers[0].activations.filter((item)=>item.activationStatus === "deactivated");
const subscriptionBlacklistedActivations = (serialNumbers)=>serialNumbers[0].activations.filter((item)=>item.activationStatus === "blacklisted");
const allowChangePlan = (subscription)=>(0,domain_plan/* isPersonalPlan */.VV)(subscription.plan) && subscription.isActive && !subscription.hasDunning && isAutoBillingSubscription(subscription) && isAllowSubscriptionChangePlanOperation(subscription);
const MIN_TRANS_AMOUNT = 0.5;
const isPurchaseSubscription = (subscription)=>subscription.allowAddons && subscription.isActive;
const isRenewSubscription = (subscription, forceRenew)=>!subscription.isTrial && (forceRenew && !subscription.isAutoBillingEnabled || subscription.allowRenew);
const isSerialNumberGenerationPending = (subscription)=>{
    var ref;
    return subscription === null || subscription === void 0 ? void 0 : (ref = subscription.lastOrder) === null || ref === void 0 ? void 0 : ref.isSerialNumberGenerationPending;
};
const isHasPaymentMethod = (subscription)=>subscription.paymentInfo !== null;


/***/ })

}]);